import { FC, useEffect, useState } from 'react';
import { qrCodeGenerator } from '@/helpers';

interface QRCodeImageProps {
  address: string;
}

const QrCodeImage: FC<QRCodeImageProps> = (props) => {
  const { address } = props;
  const [qrCodeImage, setQRCodeImage] = useState<string | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    qrCodeGenerator(address)
      .then((qrCodeDataURL: string) => {
        setQRCodeImage(qrCodeDataURL);
      })
      .catch((error: Error) => {
        console.log('Error generating QR code:', error);
      })
      .finally(() => {
        setLoading(false);
      });
  }, [address]);

  if (loading) {
    return <p>Loading...</p>;
  }

  if (!qrCodeImage) {
    return null;
  }

  return <img src={qrCodeImage} alt="QR Code" />;
};

export default QrCodeImage;
